import {
  Text,
  Flex,
  Tabs,
  TabList,
  TabPanels,
  TabPanel,
} from "@chakra-ui/react";
import { ReleasesList } from "./ReleasesList";
import { RelatedComicsList } from "./RelatedComicsList";
import { t } from "i18next";
import { ImmutableObject } from "@hookstate/core";
import { Bundle } from "../../../types";
import { Comic } from "../../../types";
import { UnderlinedTab } from "../../tabs/UnderlinedTab";
import { NewBadge } from "../../buttons/NewBadge";
import { SlideInMenuBundlesList } from "../components/SlideInMenuBundlesList";

export function ComicDetailsTabs({
  comicData,
  onLanguageChange,
}: {
  comicData: ImmutableObject<Comic> | undefined;
  onLanguageChange?: (langId: string) => void;
}) {
  const allBundles: Bundle[] = comicData?.bundles
    ? comicData.bundles.map((bundle) => bundle as unknown as Bundle)
    : [];

  const hasBundles = allBundles.length > 0;

  return (
    <Tabs variant="line" colorScheme="blaze">
      <TabList>
        <UnderlinedTab fontSize="16px">
          <Text>{t("components.slideInMenu.comicDetailsMenu.releases")}</Text>
        </UnderlinedTab>
        <UnderlinedTab fontSize="16px">
          <Text>{t("components.slideInMenu.comicDetailsMenu.related")}</Text>
        </UnderlinedTab>
        {hasBundles && (
          <UnderlinedTab fontSize="16px">
            <Flex alignItems="center" gap={2}>
              <Text>
                {t("components.slideInMenu.comicDetailsMenu.bundles")}
              </Text>
              <NewBadge />
            </Flex>
          </UnderlinedTab>
        )}
      </TabList>
      <TabPanels>
        <TabPanel px={0}>
          <ReleasesList
            comicData={comicData}
            onLanguageChange={onLanguageChange}
          />
        </TabPanel>
        <TabPanel px={0}>
          <RelatedComicsList comicData={comicData} />
        </TabPanel>
        {hasBundles && (
          <TabPanel px={0}>
            <SlideInMenuBundlesList bundles={allBundles} />
          </TabPanel>
        )}
      </TabPanels>
    </Tabs>
  );
}
